import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewEncapsulation } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { Store } from '@ngrx/store'
import { AnimationOptions } from 'ngx-lottie'
import { AppState } from 'src/app/ngrx/states'
import { network } from 'src/app/ngrx/store/actions'
import {
  DaydicTypesIconNames,
  DefaultPagination,
  LibraryChips,
  Themes,
  UserSearchResult,
} from 'src/app/shared/enums/enums'

import { CommonModule } from '@angular/common'
import { MatTableDataSource } from '@angular/material/table'
import { ActivatedRoute, Router, RouterModule } from '@angular/router'
import { InfiniteScrollDirective } from 'ngx-infinite-scroll'
import { Subscription } from 'rxjs'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { OverviewService } from 'src/app/service/data/overview.service'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { NetworkService } from 'src/app/service/network/network.service'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { DdcTabsChipsComponent } from 'src/app/shared/ddc-tabs-chips'
import { DdcLoadingSkeletonComponent } from 'src/app/shared/ddc/ddc-loading-skeleton/ddc-loading-skeleton.component'
import { DdcNotAvailableComponent } from '../../shared/ddc/ddc-not-available/ddc-not-available.component'
import { DdcUserOneComponent } from '../../shared/ddc/ddc-user-one/ddc-user-one.component'
@Component({
  selector: 'ddc-network',
  templateUrl: './ddc-network.component.html',
  styleUrls: ['./ddc-network.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  imports: [
    AngularMaterialsModules,
    CommonModule,
    RouterModule,
    DdcUserOneComponent,
    DdcNotAvailableComponent,
    InfiniteScrollDirective,
    DdcTabsChipsComponent,
    DdcLoadingSkeletonComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DdcNetworkComponent implements OnInit {
  //TODO: get it from store and after login

  _isLightTheme: boolean = true
  _isDarkTheme: boolean = false
  _isPaperTheme: boolean = false
  private themeSubscription: Subscription

  _followerSearchResults: UserSearchResult[] = []
  _followingSearchResults: UserSearchResult[] = []

  _showFollowerSearchResults: boolean = false
  _showFollowingSearchResults: boolean = false

  followerSearchDataSource: MatTableDataSource<UserSearchResult>
  followingSearchDataSource: MatTableDataSource<UserSearchResult>

  selectedRowIndexFollower = -1
  selectedRowIndexFollowing = -1

  displayedColumns: string[] = ['username', 'info', 'buttons']
  _searchTerm: string = ''
  _isInputActive = false
  _DefaultProfilePic: string = ''

  _userId: number
  _iconNames = DaydicTypesIconNames

  _followerBtnText: string = 'remove'
  _followedBtnText: string = 'unfollow'

  _nAllFollowers = 0
  _nAllFollowing = 0

  _followers: any[] = []
  _following: any[] = []

  _followersCurrentPage = 1
  _followingCurrentPage = 1

  _followersScrollLoading = false
  _followingScrollLoading = false

  _followersEnd = false
  _followingEnd = false

  _followersPerPage = DefaultPagination.OBJECT_PER_PAGE
  _followingPerPage = DefaultPagination.OBJECT_PER_PAGE

  _followersPageInfoLabel = 'Scroll down to load more'
  _followingPageInfoLabel = 'Scroll down to load more'

  _clickedColorOverview: string = 'basic'
  _clickedColorFollowers: string = 'basic'
  _clickedColorFollowing: string = 'basic'

  _isOverviewSelected: boolean = false
  _isFollowersSelected: boolean = false
  _isFollowingSelected: boolean = false

  _defaultChipOption: string = 'overview'

  _isFollowersLoading: boolean = false
  _isFollowingLoading: boolean = false
  _isOverviewLoading: boolean = false

  _isFollowersPgnLoading: boolean = false
  _isFollowingPgnLoading: boolean = false

  _isFollowersEmpty: boolean = false
  _isFollowingEmpty: boolean = false

  _fetchFollowersError: string = 'Empty.'
  _fetchFollowingError: string = 'Empty.'

  // overview
  _ovNFollowers: number
  _ovNFollowing: number

  scroll_options: AnimationOptions = {
    path: '/assets/lottie/scroll_down.json',
    loop: true, // Set loop to false for a single playthrough
    autoplay: true,
  }

  loading_options: AnimationOptions = {
    path: '/assets/lottie/loading2.json',
    loop: true, // Set loop to false for a single playthrough
    autoplay: true,
  }

  constructor(
    private logger: DdcLoggerService,
    private store: Store<AppState>,
    public dialog: MatDialog,
    private network_service: NetworkService,
    private overview_service: OverviewService,
    private route: ActivatedRoute,
    private router: Router,
    public themeService: ThemeService,
  ) {
    this.themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isLightTheme = theme === Themes.LIGHT
      this._isDarkTheme = theme === Themes.DARK
      this._isPaperTheme = theme === Themes.PAPER
    })

    this._clickedColorOverview = 'primary'
    this._isOverviewSelected = true
  }

  ngOnInit(): void {
    this.store.dispatch(network())

    this.route.params.subscribe(params => {
      const id = params['chip_code']
      this.handleDefaultChipOption(id)
    })
  }

  handleDefaultChipOption(id: number): void {
    this.logger.info('DdcNetworkComponent | handleDefaultChipOption | id:', id)
    if (id == LibraryChips.OVERVIEW) this.clickedChip('overview')
    else if (id == LibraryChips.FOLLOWERS) this.clickedChip('followers')
    else if (id == LibraryChips.FOLLOWING) this.clickedChip('following')
    else this.clickedChip(this._defaultChipOption)
  }

  clickedChip(name: string): void {
    this.logger.info('DdcNetworkComponent | clickedChip | name:', name)
    this._clickedColorOverview = 'basic'
    this._clickedColorFollowers = 'basic'
    this._clickedColorFollowing = 'basic'

    this._isOverviewSelected = false
    this._isFollowersSelected = false
    this._isFollowingSelected = false

    if (name == 'overview') {
      this._clickedColorOverview = 'accent'
      this._isOverviewSelected = true
      this.getOverview()
    } else if (name == 'followers') {
      this._clickedColorFollowers = 'accent'
      this._isFollowersSelected = true
      this.clearFollowersParameters()
      this.getFollowersPage()
    } else if (name == 'following') {
      this._clickedColorFollowing = 'accent'
      this._isFollowingSelected = true
      this.clearFollowingParameters()
      this.getFollowingPage()
    }
  }

  getOverview(): void {
    this.logger.info('DdcNetworkComponent | getOverview')
    this._isOverviewLoading = true

    this.overview_service.get_overview('network').subscribe((res: any) => {
      if (res) {
        setTimeout(() => {
          this._ovNFollowers = res.n_followers
          this._ovNFollowing = res.n_following

          this._isOverviewLoading = false
        }, 500) // two seconds
      }
    })
  }

  toggleFollowersPaginationLoading = (): void => {
    this._isFollowersPgnLoading = !this._isFollowersPgnLoading
  }

  toggleFollowingPaginationLoading = (): void => {
    this._isFollowingPgnLoading = !this._isFollowingPgnLoading
  }

  clearFollowersParameters(): void {
    this._followersCurrentPage = 1
  }

  getFollowersPage(): void {
    this.logger.info('DdcNetworkComponent | getFollowersPage()')
    this._isFollowersLoading = true
    this._followersScrollLoading = true
    this._followersPageInfoLabel = 'Loading...'

    this.toggleFollowersPaginationLoading()
    this.network_service
      .get_followers_page(this._followersCurrentPage, this._followersPerPage)
      .subscribe((res: any) => {
        if (res) {
          setTimeout(() => {
            this._followers = res.results
            this._nAllFollowers = res.count
            this._followersEnd = false
            this._followersPageInfoLabel = 'Scroll down to load more'
            this._isFollowersLoading = false
            this._followersScrollLoading = false
            this.toggleFollowersPaginationLoading()
          }, 500) // two seconds
        }
      })
  }

  clearFollowingParameters(): void {
    this._followingCurrentPage = 1
  }

  getFollowingPage(): void {
    this.logger.info('DdcNetworkComponent | getFollowingPage()')
    this._isFollowingLoading = true
    this._followingScrollLoading = true
    this._followingPageInfoLabel = 'Loading...'

    this.toggleFollowingPaginationLoading()
    this.network_service
      .get_following_page(this._followingCurrentPage, this._followingPerPage)
      .subscribe((res: any) => {
        if (res) {
          setTimeout(() => {
            this._following = res.results
            this._nAllFollowing = res.count
            this._followingEnd = false
            this._followingPageInfoLabel = 'Scroll down to load more'
            this._isFollowingLoading = false
            this._followingScrollLoading = false
            this.toggleFollowingPaginationLoading()
          }, 500) // two seconds
        }
      })
  }

  appendFollowersData = (): void => {
    this.logger.info('DdcNetworkComponent | appendFollowersData()')
    this.logger.info(
      'DdcNetworkComponent | appendFollowersData | _wordsCurrentPage:',
      this._followersCurrentPage,
    )
    this.logger.info(
      'DdcNetworkComponent | appendFollowersData | _wordsPerPage:',
      this._followersPerPage,
    )

    this._followersScrollLoading = true
    this._followersPageInfoLabel = 'Loading...'

    this.toggleFollowersPaginationLoading()
  }

  appendFollowingData = (): void => {
    this.logger.info('DdcNetworkComponent | appendFollowingData()')
    this.logger.info(
      'DdcNetworkComponent | appendFollowingData | _wordsCurrentPage:',
      this._followingCurrentPage,
    )
    this.logger.info(
      'DdcNetworkComponent | appendFollowingData | _wordsPerPage:',
      this._followingPerPage,
    )

    this._followingScrollLoading = true
    this._followingPageInfoLabel = 'Loading...'

    this.toggleFollowingPaginationLoading()
  }

  onFollowersScroll(): void {
    this.logger.info('DdcNetworkComponent | onFollowersScroll()')
    this._followersCurrentPage++
    this.appendFollowersData()
  }

  onFollowingScroll(): void {
    this.logger.info('DdcNetworkComponent | onFollowingScroll()')
    this._followingCurrentPage++
    this.appendFollowingData()
  }

  onSearchChange(type: string, searchValue: string): void {
    this._searchTerm = searchValue

    if (searchValue.length >= 2) {
      // ! Follower
      if (type == 'follower') {
        this._showFollowerSearchResults = true
        this.network_service.get_searched_followers(searchValue).subscribe((res: any) => {
          if (res) {
            this._followerSearchResults = res
            this.followerSearchDataSource.data = this._followerSearchResults
          }
        })
      }
      // ! Following
      else if (type == 'following') {
        this._showFollowingSearchResults = true
        this.network_service.get_searched_following(searchValue).subscribe((res: any) => {
          if (res) {
            this._followingSearchResults = res
            this.followingSearchDataSource.data = this._followingSearchResults
          }
        })
      }
    } else {
      this._showFollowerSearchResults = false
      this._showFollowingSearchResults = false
    }
  }

  selectNextRowFollower(): void {
    this.logger.info('DdcNetworkComponent | selectNextRowFollower()')

    if (this.selectedRowIndexFollower < this._followerSearchResults.length - 1) {
      this.selectedRowIndexFollower++
    }
  }

  selectPreviousRowFollower(): void {
    this.logger.info('DdcNetworkComponent | selectPreviousRowFollower()')

    if (this.selectedRowIndexFollower > 0) {
      this.selectedRowIndexFollower--
    }
  }

  enterEventFollower(i: number): void {
    this.logger.info('DdcNetworkComponent | enterEventFollower()')

    let clickedSearchedFollower: any = this._followerSearchResults[i]
    this.router.navigate(['/users/' + clickedSearchedFollower.username])
  }

  onBlur(event: FocusEvent): void {
    if (!event.relatedTarget || !(event.relatedTarget as HTMLElement).closest('table')) {
      this._isInputActive = false
    }
  }

  seeProfile(username: string): void {
    this.logger.info('DdcNetworkComponent | seeProfile()')
    this.router.navigate(['/users/' + username])
  }
  handleKeyDownFollower(event: KeyboardEvent): void {
    this.logger.info('DdcNetworkComponent | handleKeyDownFollower()')

    switch (event.key) {
      case 'ArrowDown':
        this.selectNextRowFollower()
        event.preventDefault()
        break
      case 'ArrowUp':
        this.selectPreviousRowFollower()
        event.preventDefault()
        break
      case 'Enter':
        this.enterEventFollower(this.selectedRowIndexFollower)
        event.preventDefault()
        break
    }
  }

  selectNextRowFollowing(): void {
    this.logger.info('DdcNetworkComponent | selectNextRowFollowing()')
    if (this.selectedRowIndexFollowing < this._followingSearchResults.length - 1) {
      this.selectedRowIndexFollowing++
    }
  }

  selectPreviousRowFollowing(): void {
    this.logger.info('DdcNetworkComponent | selectPreviousRowFollowing()')

    if (this.selectedRowIndexFollowing > 0) {
      this.selectedRowIndexFollowing--
    }
  }

  enterEventFollowing(i: number): void {
    this.logger.info('DdcNetworkComponent | enterEventFollowing()')

    let clickedSearchedFollowing: any = this._followingSearchResults[i]
    this.router.navigate(['/users/' + clickedSearchedFollowing.username])
  }

  handleKeyDownFollowing(event: KeyboardEvent): void {
    this.logger.info('DdcNetworkComponent | handleKeyDownFollowing()')

    switch (event.key) {
      case 'ArrowDown':
        this.selectNextRowFollowing()
        event.preventDefault()
        break
      case 'ArrowUp':
        this.selectPreviousRowFollowing()
        event.preventDefault()
        break
      case 'Enter':
        this.enterEventFollowing(this.selectedRowIndexFollowing)
        event.preventDefault()
        break
    }
  }

  dashboardElementClicked(element: string): void {
    this.logger.info('DdcDashboardCardComponent: dashboardElementClicked() | element:', element)

    if (element === 'followers') {
      this.router.navigate(['/network', LibraryChips.FOLLOWERS])
    } else if (element === 'following') {
      this.router.navigate(['/network', LibraryChips.FOLLOWING])
    }
  }
}
